import { defineComponent } from "vue";
import { AssetStatus } from "@pt/enums/assets";
export default defineComponent({
    props: {
        // 转码的状态
        status: {
            type: String,
            default: ""
        },
        // 转码中的进度
        progress: {
            type: Number
        },
        // 资源id
        id: {
            type: String
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        // 转码失败重试
        var retryEvent = function() {
            emit("retry", props.id);
        };
        return {
            AssetStatus: AssetStatus,
            retryEvent: retryEvent
        };
    }
});
